import * as React from 'react';
import isEqual from 'react-fast-compare';
import ReactGA from 'react-ga4';
import * as ReactGALegacy from 'react-ga';
import { connect } from 'react-redux';
import DataLoader from './common/loader/data-loader';
import Modal from './common/modal/modal';
import AppMenu from './menu/components/app-menu';
import PerformanceMessaging from './menu/components/performance-messaging';
import { IAppState } from './reducers/index';
import { showLevelFilters, showPerformanceDatesFilters, showPriceRangeFilters, showPriceTypeFilters, showSpecialSeatingFilters } from './helpers/state-helpers';
import { ItemType } from './classes/item-type';
import { selectVenueLevel } from './seatmap/actions/seatmap-actions';
import { confirmReserveResult } from './cart/actions/cart-fetch';
import { fetchSeatMap } from './seatmap/actions/seatmap-fetch';
import DiagnosticModal from './common/modal/diagnostic-modal';
import ModalState from './common/modal/modal-states';

interface IApplicationState {
    loadingText: string;
    diagnosticModalState: ModalState;
}

class App extends React.Component<IAppState, IApplicationState>{
    constructor(props: IAppState) {
        super(props);

        this.state = {
            loadingText: (window as any).loadingText,
            diagnosticModalState: ModalState.CLOSE
        }

        setTimeout(() => {
            let reactLoaderButton = document.getElementById("react-loader-button");

            if (reactLoaderButton !== undefined && props.appSettingsModel.stopLoadingAnimationButtonText !== "") {
                reactLoaderButton.setAttribute('style', "visibility: visible;");
            }
        }, 5000);
    }

    shouldComponentUpdate(nextProps: IAppState, nextState) {
        const propsChanged = !isEqual(this.props, nextProps);
        const stateChanged = !isEqual(this.state, nextState);
        return propsChanged || stateChanged;
    }

    render() {

        let showLevelSelectFilter = showLevelFilters(this.props.appSettingsModel);
        let showPriceRangeFilter = showPriceRangeFilters(this.props.priceRangeModel);
        let showPriceTypeFilter = showPriceTypeFilters(this.props.appSettingsModel);
        let showSpecialSeatingFilter = showSpecialSeatingFilters(this.props.appSettingsModel);
        let showPerformanceDates = showPerformanceDatesFilters(this.props.appSettingsModel);

        return (
            <>
                {
                    (!this.props.appSettingsModel.itemId && !this.props.errorModel.getAppSettingsFailed) || this.props.applicationModel.loading ?
                        <DataLoader loadingSvgText={(window as any).loadingSvgText} loadingText={this.state.loadingText} />
                        :
                        <>
                            <AppMenu
                                {...this.props.appSettingsModel}
                                isSyosOnlyConfig={this.props.appSettingsModel.isSelectSeatVenue}
                                clientSymbolUrl={this.props.appSettingsModel.clientLeftNavLinkUrl}
                                rightNavUrl={this.props.appSettingsModel.clientRightNavLinkUrl}
                                headingTitle={this.props.appSettingsModel.itemNameRichText}
                                altText={this.props.appSettingsModel.altText}
                                cartConflictErrorHeading={this.props.appSettingsModel.cartConflictErrorHeading}
                                viewFromSeatModalActive={this.props.applicationModel.viewFromSeatModalActive}
                                dispatch={this.props.dispatch}
                                isExchange={this.props.appSettingsModel.exchangeTickets.length > 0}
                                isSeatmapView={this.props.location.pathname === "/seatmap" || this.props.appSettingsModel.itemType === ItemType.Exchange || (this.props.appSettingsModel.isSelectSeatVenue ? true : false)}
                                performanceDateString={this.props.location.pathname === "/seatmap" ? `${this.props.appSettingsModel.performanceDateString} | ${this.props.appSettingsModel.performanceTimeString}` : null}
                                seatmapFiltersIsOpen={this.props.seatMapModel.openSeatmapFilters}
                                seatmapCartIsOpen={this.props.seatMapModel.openSeatmapCart}
                                seatmapCartText={this.props.appSettingsModel.cartTitle}
                                cartSeatsCount={this.props.cartModel.seats.length}
                                cartTimerMessaging={this.props.appSettingsModel.cartTimerWithCountMessage}
                                cartUrl={this.props.appSettingsModel.cartUrl}
                                cartTimerExpiringMinute={this.props.appSettingsModel.cartTimerExpiringMinute}
                                remainingCartTimer={this.props.cartModel.remainingTessituraCartTimer}
                                showFiltersToggle={showLevelSelectFilter || showPriceRangeFilter || showPriceTypeFilter || showPerformanceDates || showSpecialSeatingFilter}
                                cartExpiredTitle={this.props.appSettingsModel.cartExpiredTitle}
                                cartExpiredMessage={this.props.appSettingsModel.cartExpiredMessage}
                                cartExpiredConfirmText={this.props.appSettingsModel.cartExpiredConfirmText}
                                disableCartExpiredPopup={this.props.appSettingsModel.disableCartExpiredPopup}
                            />

                            {this.props.appSettingsModel.performanceMessaging != null && this.props.appSettingsModel.performanceMessaging.length > 0 ?
                                <PerformanceMessaging performanceMessaging={this.props.appSettingsModel.performanceMessaging} />
                                : null
                            }
                            {
                                this.props.appSettingsModel.pricingRulesMessaging.length > 0 ?
                                    <PerformanceMessaging performanceMessaging={this.props.appSettingsModel.pricingRulesMessaging} />
                                    : null
                            }
                            {
                                this.props.cartModel.reservingSeats ?
                                    <div className="loading-container">
                                        <DataLoader loadingSvgText={(window as any).loadingSvgText} loadingText={this.props.appSettingsModel.reservingSeatMessage} />
                                    </div>
                                    : null
                            }
                            {this.props.cartModel.reserveResult != null ?
                                <Modal modalKey="reserve result" isError={true} title={this.props.cartModel.reserveResult.errorTitle}
                                    message={this.props.cartModel.reserveResult.message}
                                    confirmFunction={this._reserveResultRedirect.bind(this)}
                                    closeFunction={this._reserveResultRedirect.bind(this)}
                                    confirmString={this.props.cartModel.reserveResult.redirectButtonText}
                                    priority={1}
                                />
                                : null
                            }
                            {this.props.children}
                        </>
                }
                {this.renderDiagnosticModalTrigger()}
                {this.renderDiagnosticModal()}
            </>
        );
    }

    _reserveResultRedirect() {
        if (location.href === this.props.cartModel.reserveResult.redirectUrl) {
            const currentLevel = this.props.venueLevelModel.venueLevels.filter(lvl => lvl.id === this.props.seatMapModel.levelId);

            if (currentLevel) {
                this.props.dispatch(confirmReserveResult());
                this.props.dispatch(fetchSeatMap(this.props.seatMapModel.seatmapId, [], false, []));
            } else {
                location.reload();
            }
        } else {
            location.replace(this.props.cartModel.reserveResult.redirectUrl);
        }
    }

    renderDiagnosticModal() {
        if (this.props.appSettingsModel.isDiagnosticModeActive && this.state.diagnosticModalState == ModalState.OPEN) {
            return <DiagnosticModal
                modalKey="Diagnostic Mode"
                title={"Diagnostic Display"}
                message={""}
                closeFunction={this._closeDiagnosticModal.bind(this)}
                appSettings={this.props.appSettingsModel}
            />
        }
    }

    renderDiagnosticModalTrigger() {
        if (this.props.appSettingsModel.isDiagnosticModeActive) {
            return (
                <div className="btn-diagnostic-container">
                    <button type="button" className="btn-diagnostic" onClick={this._openDiagnosticModal.bind(this)}>
                        Diagnostic Mode
                        <svg className="svg-icon"><use xlinkHref="#icon-palette" /></svg>
                    </button>
                </div>
            )
        }
    }

    _openDiagnosticModal() {
        this.setState({
            diagnosticModalState: ModalState.OPEN
        })
    }

    _closeDiagnosticModal() {
        this.setState({
            diagnosticModalState: ModalState.CLOSE
        })
    }

    componentDidMount() {
        if (this.props.appSettingsModel.googleAnalyticsId != null &&
            this.props.appSettingsModel.googleAnalyticsId.length > 0 &&
            this.props.appSettingsModel.googleAnalyticsId[0] == 'G') {
            ReactGA.initialize([
                { trackingId: this.props.appSettingsModel.googleAnalyticsId }
                , { trackingId: "G-34E9QDPEGN" }
            ]);
        }
        else {
            ReactGALegacy.initialize(this.props.appSettingsModel.googleAnalyticsId);
        }
    }
}

//export default Filter;
export default connect((state) => state)(App);